import api from 'api';
import { WEB_API_ROUTES } from 'api/api-routes';
import { createThunk } from '../../utils/store-utils';

export const thunks = {
  authSendVerification: createThunk('auth/sendVerification', (login) =>
    api.post(WEB_API_ROUTES.auth.sendVerification, {
      login,
    })
  ),

  login: createThunk('auth/login', ({ credentials, code }) => {
    const body = {
      code,
      method: 'code',
    };

    if (credentials.type === 'email') {
      body.email = credentials.value;
    }

    if (credentials.type === 'phone') {
      body.phone = credentials.value;
    }

    return api.post(WEB_API_ROUTES.auth.login, body);
  }),

  refreshToken: createThunk('auth/refreshToken', (_, { getState }) => {
    const { auth } = getState();

    return api.post(WEB_API_ROUTES.auth.refreshToken, {
      refresh_token: auth.refreshToken,
    });
  }),

  sendLogout: createThunk('auth/logout', () =>
    api.post(WEB_API_ROUTES.profile.logout)
  ),
};
